<div class="eiq-input-action">
  <span class="fs__sm fw__500 label">
    {{ label }} <span class="fs__xs caption">{{ hint }}</span>
  </span>
  <div class="eiq-input-action__field">
    <mat-form-field appearance="outline" class="eiq-input-action__field-form" [subscriptSizing]="'dynamic'">
      <input
        matInput
        autocomplete="false"
        [type]="type"
        [placeholder]="placeholder"
        [value]="currentValue"
        [formControl]="control"
        (input)="setValue($event)"
        (keyup.enter)="keyupEnter.emit()"
      />
      <mat-error><eiq-validation-text [formCtrl]="control"></eiq-validation-text></mat-error>
    </mat-form-field>
    <button
      matSuffix
      mat-icon-button
      class="eiq-input-action__field-button"
      [color]="'light'"
      [disabled]="!control.value || control.invalid"
      (click)="clicked.emit()"
    >
      @if (icon) {
        <fa-icon [icon]="icon"></fa-icon>
      }
      {{ actionText }}
    </button>
  </div>
</div>
